import { array, number, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { WholeHouseId as WholeHouseAncillaryItemId } from '../../../../job/ancillary-item';
import { Id as FormulaId } from '../../../../whole-house/formula/Id';

export const Request = struct({
	name: iotsUtils.NotEmptyString,
	takeoffType: WholeHouseAncillaryItemId,
	wastage: number,
	formulaIds: array(FormulaId),
});
